import { Routes } from '@angular/router';
import { LANDING_BASE_PATH, LANDING_PAGE } from './landing.config';

export function landingRoutes(): Routes {
  return [
    {
      path: LANDING_BASE_PATH,
      loadComponent: () =>
        import('./landing.component').then((m) => m.LandingComponent),
      runGuardsAndResolvers: 'paramsChange',
      data: {
        landing: true,
        page: {
          seo: LANDING_PAGE.seo,
        },
      },
    },
    {
      path: `${LANDING_BASE_PATH}/:slug`,
      loadComponent: () =>
        import('./landing.component').then((m) => m.LandingComponent),
      runGuardsAndResolvers: 'paramsChange',
      data: {
        landing: true,
        page: {
          seo: LANDING_PAGE.seo,
        },
      },
    },
  ];
}
